import { LessonProblem } from '@yandex-int/k-common/typings';
import { MdState } from 'platform-components/src/components/marker/types';
// @ts-ignore
import * as userSelectors from 'platform-components/src/components/user/selectors';
// @ts-ignore
import { getMdStateFromProblem } from 'platform-components/src/utils/md-state';
import { createSelector } from 'reselect';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { getSelectedProblemLink } from 'common.components/lesson-view.store/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { getUserAnswer } from 'store/problems-view/selectors';
import * as problemSelectors from 'store/problems/selectors';
import { ProblemInfo } from 'store/problems/typings';
import { getProblemInfo as getProblemInfoUtil, isDictation } from 'store/problems/utils';

export const getIsInitialAnswer = createSelector(
    [getUserAnswer, getSelectedProblemLink],
    (userAnswer, problemLink: LessonProblem) => {
        if (!userAnswer || Object.values(userAnswer).length === 0) {
            return true;
        }

        const isDictationProblem = problemLink?.problem && isDictation(problemLink.problem);

        return Object.values(userAnswer).every((answer: any) => {
            if (!answer || !answer.user_answer) {
                return true;
            }

            if (isDictationProblem && !answer.user_answer.text) {
                return true;
            }

            return Object.keys(answer.user_answer).every((key) => {
                const data = answer.user_answer[key];

                return data === null;
            });
        });
    }
);

export const getProblemMdState = createSelector(
    [lessonViewSelectors.getSelectedProblemLink],
    (problemLink): MdState | null => {
        if (!problemLink || !problemLink.problem) {
            return null;
        }

        return getMdStateFromProblem(problemLink.problem);
    }
);

export const getProblemInfo = createSelector(
    [lessonViewSelectors.getSelectedProblemLink],
    (problemLink): ProblemInfo | null => {
        if (!problemLink || !problemLink.problem) {
            return null;
        }

        return getProblemInfoUtil(problemLink.problem);
    }
);

export const getShouldShowProblemInfoControl = createSelector(
    [getProblemInfo, userSelectors.getIsContentManager],
    (info, isCm: boolean): boolean => {
        if (info === null) {
            return false;
        }

        return Boolean(info.solution || info.publicSolution || (isCm && info.comment));
    }
);

export const getHasVariants = createSelector(
    [problemSelectors.getProblemsByStackId],
    (problemsByStackId: Array<LessonProblem>): boolean => problemsByStackId.length > 1
);

export const getShouldShowProblemVariantsControl = createSelector(
    [getHasVariants, lessonSelectors.getCanEditLesson, lessonViewSelectors.getCanAddProblemToLesson],
    (hasVariants: boolean, canEditLesson: boolean, canAddProblemToLesson: boolean): boolean =>
        hasVariants && canEditLesson && canAddProblemToLesson
);

export const getShouldShowProblemEditButton = createSelector(
    [userSelectors.getIsContentManager, lessonSelectors.getIsPreparedLesson],
    (isCm: boolean, isPreparedLesson: boolean): boolean => isCm && !isPreparedLesson
);

export const getShouldShowDeleteProblemButton = createSelector(
    [lessonSelectors.getCanEditLesson],
    (canEditLesson: boolean): boolean => canEditLesson
);
